define([
    'text!fnjinews/component/image-slick.html',
    // 'common/api',
    'jquery',
    '../../../../vendor/slick/slick.js',

    'css!vendor/slick/slick.css',
    'css!vendor/slick/slick-theme.css',
    'css!fnjinews/component/image-slick.css'

], function(
    tpl,
    // Api,
    $
){
    return {
        template: tpl,
        data: function(){
            return {
                img: [
                    'https://static.fnji.com/view-v2/web/site/high-end-line/image/fnjinews_slick1.png?imageMogr2/thumbnail/2048x%3E/quality/100!/sharpen/1',
                    'https://static.fnji.com/view-v2/web/site/high-end-line/image/fnjinews_slick2.png?imageMogr2/thumbnail/2048x%3E/quality/100!/sharpen/1',
                    'https://static.fnji.com/view-v2/web/site/high-end-line/image/fnjinews_slick3.png?imageMogr2/thumbnail/2048x%3E/quality/100!/sharpen/1'
                ],
            };
        },
        // 这里是传入的数据
        props: {
            SlickImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            dotsShow: {
                type: Number
            }
        },
        methods: {
            init: function () {
                var _this = this;
                var bool = _this.dotsShow===1;
                _this.$nextTick(function () {
                    $('.slick').slick({
                        pauseOnHover: false,
                        autoplay: true,
                        fade: true,
                        infinite: true,
                        accessibility: false,
                        arrows: false,
                        dots: bool
                    });
                })
            }
        },
        watch: {
            SlickImage: function () {
                this.init();
            }
        },
        mounted: function(){
            this.init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./fnjinews/component/image-slick.js
// module id = 120
// module chunks = 0